import { PRIORITY_FILTER_DROPDOWN_DATA, TICKET_TYPE_CONSTANTS } from './constant';
import { isEmptyObject } from 'helpers/objectFunctions';
import { format, isToday, isYesterday, parseISO } from 'date-fns';
import { devConsolelog } from 'helpers/utilityFunctions';

export const handleFiltersValue = (key, filters = {}) => {
    if (key === 'category' || key === 'request_type' || key === 'tags') {
        const temp = [];
        if (isEmptyObject(filters)) return temp;
        const obj = filters[key] || {};
        Object?.values(obj)?.forEach((item) => {
            temp.push(item);
        });
        return temp;
    }
    if (key === 'status' || key === 'search') {
        const obj = filters[key] || {};
        return Object?.values(obj)?.[0]?.id || '';
    }
    if (key === 'TICKET_TYPE') {
        if (filters?.[TICKET_TYPE_CONSTANTS?.my_tickets]) {
            return 'my_tickets';
        }
        if (filters?.[TICKET_TYPE_CONSTANTS?.my_raised_tickets]) {
            return 'my_raised_tickets';
        }
        if (filters?.[TICKET_TYPE_CONSTANTS?.others]) {
            return 'others';
        }
        return '';
    }
    if (key === 'team' || key === 'userName') {
        const obj = filters[key] || {};
        return Object?.values(obj)?.[0]?.name || '';
    }
    if (key === 'priority_type') {
        const obj = filters[key] || {};
        return PRIORITY_FILTER_DROPDOWN_DATA?.find((item) => item?.id === Object?.values(obj)?.[0]?.id) || '';
    }
    if (key === 'updated_at') {
        const obj = filters[key] || {};
        const currentDate = new Date();
        const appliedDate = new Date(Object?.keys(obj)?.[0] || '');
        const diffDate = (currentDate - appliedDate) / (1000 * 60 * 60 * 24);
        switch (true) {
            case diffDate <= 1:
                return 'today';

            case diffDate > 1 && diffDate <= 2:
                return 'yesterday';

            case diffDate > 2 && diffDate <= 3:
                return 'last_3_days';

            case diffDate > 3 && diffDate <= 7:
                return 'last_7_days';

            case diffDate > 7 && diffDate <= 15:
                return 'last_15_days';

            case diffDate > 15 && diffDate <= 30:
                return 'last_30_days';

            default:
                return '';
        }
    }
    return '';
};
export const makeUrlFromObj = (obj = {}) => {
    let path = '';
    Object?.keys(obj)?.forEach((key) => {
        Object?.values(obj[key])?.forEach((item) => {
            path += `${key}=${item?.id || item}&`;
        });
    });

    return path.substring(0, path?.length - 1);
};
export const navigatePathOnFilter = (filtersUrl, navigate) => {
    const path = '/internal-commenting';
    navigate(`${path}?${filtersUrl}`);
};
export const getCodeValue = (data = [], matchKey = '', value, returnKey = '') => {
    if (data?.length > 0 && matchKey && returnKey) {
        return data?.find((item) => item?.[matchKey] === Number(value) || item?.[matchKey] === value)?.[returnKey] || value;
    }
    return value;
};
export const makeFilterObj = (arr = []) => {
    const obj = {};
    if (arr?.length > 0) {
        arr?.forEach((item) => {
            const [key, value] = Object?.entries(item)?.[0];
            if (key && value) {
                obj[key] = value;
            }
        });
    }
    return obj;
};
export const makeFilterObjFromSearchParams = (
    search = '',
    teamsFilterData = [],
    tagsFilterData = [],
    filters = {},
    makeChatFilterList = false,
    selectedTab = 1
) => {
    const obj = {};
    const filterArr = [selectedTab === 1 ? 'travClan help' : 'Internal Query'];
    const arr = search?.split('?');
    if (search?.includes('?')) {
        const splitParams = arr?.[1].split('&');
        const filtersData = makeFilterObj(filters);
        splitParams?.forEach((item) => {
            const [key, value] = item?.split('=');
            let data = [];
            if (filtersData?.[key]) {
                data = filtersData[key];
            } else if (key === 'tags') {
                data = tagsFilterData;
            } else if (key === 'team') {
                data = teamsFilterData;
            }
            if (key === 'next_action_at') {
                const myObj = obj?.[key] ? obj?.[key] : {};
                if (value === 'true') {
                    obj[key] = { ...myObj, isDateFilter: value };
                    filterArr.push('next action date');
                } else if (myObj?.start_date) {
                    obj[key] = { ...myObj, end_date: value };
                    devConsolelog('value373637', value);
                    filterArr.push(value ? format(new Date(value), 'do MMMM yyyy') : null);
                } else {
                    obj[key] = { ...myObj, start_date: value };
                    filterArr.push(value ? format(new Date(value), 'do MMMM yyyy') : null);
                }
            } else if (!obj?.[key]) {
                const name = getCodeValue(data, 'id', value, 'name');
                if (key !== 'query_type') filterArr.push(name);
                obj[key] = { [value]: { id: value, name } };
            } else {
                const name = getCodeValue(data, 'id', value, 'name');
                obj[key] = { ...obj[key], [value]: { id: value, name } };
                if (key !== 'query_type') filterArr.push(name);
            }
        });
    }
    if (makeChatFilterList) return filterArr;
    return obj;
};

export const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < arr1.length; i++) {
        let codeExists = false;
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < arr2.length; j++) {
            if (arr1[i].code === arr2[j].code) {
                codeExists = true;
                break;
            }
        }
        if (!codeExists) {
            return false;
        }
    }

    return true;
};

export const priorityColors = {
    1: '#00C853', // Green for low priority
    2: '#FFEB3B', // Yellow for medium priority
    3: '#FF5722', // Orange for high priority
    4: '#F44336', // Red for critical priority
    5: '#9E9E9E'
};

export const formatDate = (dateString) => {
    const parsedDate = parseISO(dateString);

    if (isToday(parsedDate)) {
        return format(parsedDate, 'HH:mm');
    }
    if (isYesterday(parsedDate)) {
        return 'Yesterday';
    }
    return format(parsedDate, 'MM/dd/yyyy');
};
